export default __webpack_public_path__ + "static/media/loading_box.3ad1f782.svg";